import { useEffect, useState } from "react";
import axios from "axios";
import { KeyRound, Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { GoalsTab } from "@/components/Goals";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };
const errText = (err, fallback) => { const d = err.response?.data?.detail; return typeof d === "string" ? d : fallback; };

const UserRow = ({ u }) => {
  const [pwd, setPwd] = useState("");
  const reset = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/admin/users/${u.id}/reset-password`, { new_password: pwd }, cfg); toast.success(`Senha de ${u.church} redefinida`); setPwd(""); }
    catch (err) { toast.error(errText(err, "A senha deve ter pelo menos 6 caracteres.")); }
  };
  return <form className="admin-row" onSubmit={reset} data-testid={`admin-user-row-${u.id}`}>
    <div><strong>{u.church}</strong><small>{u.email}</small></div>
    <input data-testid={`admin-reset-input-${u.id}`} type="text" minLength={6} required value={pwd} onChange={e => setPwd(e.target.value)} placeholder="Nova senha" />
    <button data-testid={`admin-reset-button-${u.id}`} className="secondary-btn"><KeyRound size={15} /> Redefinir</button>
  </form>;
};

const PasswordsTab = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/users`, cfg).then(r => setUsers(r.data)); }, []);
  return <div className="admin-list">{users.map(u => <UserRow key={u.id} u={u} />)}</div>;
};

const CategoriesTab = ({ categories, onChange }) => {
  const [name, setName] = useState("");
  const add = async (e) => {
    e.preventDefault();
    try { const r = await axios.post(`${API}/admin/expense-categories`, { name }, cfg); onChange(r.data); setName(""); toast.success("Tipo de saída adicionado"); }
    catch (err) { toast.error(errText(err, "Informe um nome com pelo menos 2 letras.")); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Remover o tipo "${c}"? Lançamentos antigos continuam salvos.`)) return;
    try { const r = await axios.delete(`${API}/admin/expense-categories/${encodeURIComponent(c)}`, cfg); onChange(r.data); toast.success("Tipo removido"); }
    catch (err) { toast.error(errText(err, "Não foi possível remover.")); }
  };
  return <div>
    <form className="admin-add" onSubmit={add}><input data-testid="admin-category-input" required minLength={2} value={name} onChange={e => setName(e.target.value)} placeholder="Ex.: Aluguel, Material de limpeza" /><button data-testid="admin-category-add-button" className="primary-btn compact"><Plus size={16} /> Adicionar</button></form>
    <ul className="admin-chips">{categories.map(c => <li key={c} data-testid={`admin-category-${c}`}>{c}{c === "Outros" ? <small>fixo</small> : <button data-testid={`admin-category-delete-${c}`} className="row-btn danger" onClick={() => remove(c)}><Trash2 size={14} /></button>}</li>)}</ul>
  </div>;
};

export const AdminPanel = ({ churches, categories, onCategoriesChange, onClose }) => {
  const [tab, setTab] = useState("passwords");
  return <div className="modal-backdrop"><div className="modal admin-modal" data-testid="admin-panel">
    <button data-testid="admin-panel-close-button" className="icon-btn close" onClick={onClose}><X /></button>
    <p className="eyebrow">ADMINISTRAÇÃO</p><h2>Configurações</h2>
    <div className="segmented"><button data-testid="admin-tab-passwords" type="button" className={tab === "passwords" ? "active" : ""} onClick={() => setTab("passwords")}>Senhas das filiais</button><button data-testid="admin-tab-categories" type="button" className={tab === "categories" ? "active" : ""} onClick={() => setTab("categories")}>Tipos de saída</button><button data-testid="admin-tab-goals" type="button" className={tab === "goals" ? "active" : ""} onClick={() => setTab("goals")}>Metas</button></div>
    {tab === "passwords" && <PasswordsTab />}{tab === "goals" && <GoalsTab churches={churches} />}{tab === "categories" && <CategoriesTab categories={categories} onChange={onCategoriesChange} />}
  </div></div>;
};
